var render = function render(){
  var _vm$form$product, _vm$form$product2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "833",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connect')))]), _c('span', [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_product')))])]), _c('div', [_c('v-stepper', {
    staticClass: "shadow-none",
    attrs: {
      "non-linear": ""
    },
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_select_product')))]), _c('v-divider'), _c('v-stepper-step', {
    staticClass: "text-capitalize",
    attrs: {
      "step": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connect')))])], 1), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-form', {
    ref: "productForm",
    staticClass: "mx-8 mb-10",
    model: {
      value: _vm.isFormValid,
      callback: function ($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-autocomplete', {
    staticClass: "custom-text-field",
    attrs: {
      "disabled": _vm.disableFields,
      "rules": _vm.productRules,
      "placeholder": _vm.productPlaceholder,
      "hint": _vm.$t('amazon_transparency_search_select'),
      "items": _vm.products,
      "loading": _vm.isLoading,
      "search-input": _vm.search,
      "append-icon": "",
      "hide-details": "auto",
      "item-text": _vm.getProductLabel,
      "hide-no-data": false,
      "no-data-text": '',
      "return-object": "",
      "required": "",
      "outlined": "",
      "dense": "",
      "single-line": "",
      "persistent-hint": "",
      "clearable": "",
      "error-messages": _vm.errorMessages.product,
      "attach": true
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": [function ($event) {
        _vm.search = $event;
      }, _vm.handleSearchInput],
      "click:clear": _vm.onClear,
      "focus": _vm.onAutocompleteFocus,
      "blur": function ($event) {
        _vm.focusStates.productAutoComplete = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c('v-list-item', [_c('v-list-item-content', [!_vm.isLoading && _vm.displayNoData ? _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_no_products_found')) + " ")]) : _vm._e()], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.product,
      callback: function ($$v) {
        _vm.$set(_vm.form, "product", $$v);
      },
      expression: "form.product"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4 custom-text-field",
    attrs: {
      "counter": 14,
      "rules": _vm.gtinRules,
      "placeholder": _vm.gtinPlaceholder,
      "hint": _vm.$t('amazon_transparency_search_gtin_registered'),
      "disabled": _vm.disableFields,
      "hide-details": "auto",
      "required": "",
      "single-line": "",
      "outlined": "",
      "dense": "",
      "persistent-hint": "",
      "error-messages": _vm.errorMessages.gtin
    },
    on: {
      "focus": function ($event) {
        _vm.focusStates.gtinTextField = true;
      },
      "blur": function ($event) {
        _vm.focusStates.gtinTextField = false;
      }
    },
    model: {
      value: _vm.form.gtin,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gtin", $$v);
      },
      expression: "form.gtin"
    }
  }), _c('v-textarea', {
    staticClass: "mt-4 custom-text-field",
    attrs: {
      "placeholder": _vm.remarkPlaceholder,
      "hint": _vm.$t('amazon_transparency_additional_details'),
      "disabled": _vm.disableFields,
      "hide-details": "auto",
      "single-line": "",
      "outlined": "",
      "dense": "",
      "persistent-hint": "",
      "auto-grow": "",
      "counter": "300",
      "rules": _vm.remarkRules,
      "error-messages": _vm.errorMessages.remark
    },
    on: {
      "focus": function ($event) {
        _vm.focusStates.remarkTextArea = true;
      },
      "blur": function ($event) {
        _vm.focusStates.remarkTextArea = false;
      }
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('div', {
    staticClass: "mx-2",
    class: {
      'mt-4': _vm.isConnectionOrConnectionFailed
    }
  }, [_c('v-row', {
    staticClass: "pt-0"
  }, [_c('v-col', [_vm.isConnected || _vm.isConnecting ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-status mr-5"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connection_status')))]), _vm.isConnected ? _c('span', {
    staticClass: "text-connected text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connected')))]) : _vm._e(), _vm.isConnecting ? _c('span', {
    staticClass: "text-connecting"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connection_progress')))]) : _vm._e()]) : _vm._e(), _vm.isConnected ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-switch', {
    staticClass: "flex-shrink-0 h-35",
    attrs: {
      "label": ""
    },
    on: {
      "change": _vm.toggleSwitch
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "ml-4 font-weight-bold black--text"
        }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_auto_upload')))])];
      },
      proxy: true
    }], null, false, 1340938979),
    model: {
      value: _vm.isAutoUpload,
      callback: function ($$v) {
        _vm.isAutoUpload = $$v;
      },
      expression: "isAutoUpload"
    }
  }), _c('div', {
    staticClass: "d-flex ml-64"
  }, [_c('span', {
    staticClass: "text-wrap text-auto-upload"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_by_enabling')) + " \"" + _vm._s(_vm.$t('amazon_transparency_auto_upload')) + ",\" " + _vm._s(_vm.$t('amazon_transparency_qrcode_auto_upload')) + " ")])])], 1) : _vm._e(), _vm.isConnectionFailed ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "text-status mr-5"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connection_status')))]), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-failed text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_failed')))])]), _c('span', {
    staticClass: "text-error mt-1"
  }, [_vm._v(_vm._s(_vm.failedErrorMessage))])])]), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-uppercase mb-6",
    attrs: {
      "color": "primary",
      "loading": _vm.isReconnecting
    },
    on: {
      "click": _vm.handleReconnectBtnClick
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_reconnect')))])], 1) : _vm._e()])], 1), _vm.isConnectionOrConnectionFailed || _vm.isConnecting ? _c('v-divider', {
    staticClass: "mt-4"
  }) : _vm._e(), _c('v-row', {
    class: {
      'mt-4': _vm.isConnectionOrConnectionFailed || _vm.isConnecting
    }
  }, [_c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "mr-10 font-weight-bold text-capitalize w-80 text-bold flex-shrink-0",
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_product')))]), _c('span', {
    staticClass: "text-wrap",
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s((_vm$form$product = _vm.form.product) === null || _vm$form$product === void 0 ? void 0 : _vm$form$product.name))])])]), _c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "font-weight-bold text-capitalize text-bold w-80 flex-shrink-0 mr-2",
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_sku')))]), _c('span', {
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s((_vm$form$product2 = _vm.form.product) === null || _vm$form$product2 === void 0 ? void 0 : _vm$form$product2.sku))])])])], 1), _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "mr-10 font-weight-bold text-capitalize text-bold w-80 flex-shrink-0",
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_gtin_14')))]), _c('span', {
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s(_vm.form.gtin))])])])], 1), _vm.form.remark ? _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "mr-10 font-weight-bold text-capitalize text-bold w-80 flex-shrink-0",
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_remark')))]), _c('span', {
    class: _vm.greyTextColor
  }, [_vm._v(_vm._s(_vm.form.remark))])])])], 1) : _vm._e()], 1)])], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "pa-4 px-8 mt-3 pb-6"
  }, [_vm.step === 2 ? _c('div', [!_vm.isConnected && !_vm.isConnecting || _vm.isRegisteringProduct ? _c('v-btn', {
    staticClass: "text-uppercase mr-4",
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.isRegisteringProduct
    },
    on: {
      "click": _vm.handleBackBtnClick
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_back')))]) : _vm._e(), (_vm.isConnected || _vm.isConnecting) && !_vm.isRegisteringProduct ? _c('v-btn', {
    staticClass: "text-uppercase mr-4",
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.handleConnectAnotherProduct
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connect_another_product')))]) : _vm._e()], 1) : _vm._e(), _c('v-spacer'), _vm.step === 1 ? _c('div', [_vm.step === 1 ? _c('v-btn', {
    staticClass: "text-uppercase mr-4",
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_cancel')))]) : _vm._e(), _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "primary",
      "loading": _vm.isConnecting,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.handleNextBtnClick
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_next')))])], 1) : _vm._e(), _vm.step === 2 ? _c('div', [!_vm.isConnected && !_vm.isConnectionFailed && !_vm.isConnecting ? _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "primary",
      "loading": _vm.isConnecting
    },
    on: {
      "click": _vm.handleConnectBtnClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_connect')) + " ")]) : _vm._e(), _vm.isConnected || _vm.isConnectionFailed || _vm.isConnecting ? _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_close')))]) : _vm._e()], 1) : _vm._e()], 1)], 1), _c('auto-upload-confirmation-modal', {
    attrs: {
      "display-confirmation-modal": _vm.showConfirmationModal,
      "handle-cancel-btn": _vm.handleCancelBtn,
      "handle-disable-btn": _vm.handleDisableBtn,
      "handle-enable-btn": _vm.handleEnableBtn,
      "is-disabling": _vm.isDisablingAutoUpload
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }